define.alias("shared/components/shared/referral-promo-banner", "preview-grid/components/shared/referral-promo-banner");